import { ScrollTrigger } from "../LibrariesImport";

export default class Header {
	static init() {
		this.header = document.querySelector(".header-minimal");
		if (this.header) {
			this.toggleHeader();
		}
	}

	static toggleHeader() {
		ScrollTrigger.create({
			trigger: '.banner',
			start: 'top -5%',
			end: '+=999999px',
			onToggle: (self) => {
				this.header.classList.toggle('is-on-top', self.isActive);
			},
		});
	}
}
